import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { StudentService } from './student.service';
import { StudentOption } from '../_model/student-option.model';

/**
 * Finds a student of this school by name or national ID, for the Add Parent
 * picker.
 *
 * Thin on purpose: the endpoint does the searching, the capping and the
 * ordering, and this only translates its shape into what the picker renders.
 * Everything the UI knows about finding a student comes through `search()`.
 */
@Injectable({ providedIn: 'root' })
export class StudentLookupService {

  constructor(private studentService: StudentService) { }

  /**
   * Students matching `term`. An empty term matches nothing — the endpoint
   * answers `[]` rather than dumping the school, and there is no reason to ask
   * it at all.
   */
  search(term: string): Observable<StudentOption[]> {
    const query = (term || '').trim();
    if (!query) {
      return of([]);
    }
    return this.studentService.searchStudents(query).pipe(
      map((res: any) => (res || []).map(student => this.toOption(student)))
    );
  }

  /** Grade and class arrive as objects here, unlike the paginated list. */
  private toOption(student: any): StudentOption {
    return {
      id: student?.id,
      name: student?.name,
      national_id: student?.national_id,
      grade: student?.grade?.name,
      class: student?.class?.name
    };
  }
}
